import { createAction } from '@reduxjs/toolkit'

import type { XmlImportModel } from '@/utils/xml'

interface ImportXmlPayload {
  model: XmlImportModel
  teamId?: string | null
}

export const XmlImportActions = {
  import: createAction<ImportXmlPayload>('XML_IMPORT_SAGA'),
}
